"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  importCargoInfo: {
    title: 'Inbound Cargo Information',
    blNo: 'B/L No.',
    containerNo: 'Container No.',
    tips_1: 'Warm Tips：',
    tips_2: '(1) The time and cost information of the exchangeable order for import is for reference only, and the actual written notice such as mail and fax shall prevail.',
    tips_3: '(2) The result of free days of demurrage fee is for reference only.',
    cargoInfo: 'Arrival information',
    baseInfo: 'Base Info',
    containerInfo: 'Container Info',
    vesselName: 'Vessel Name',
    voyageNo: 'Voyage No.',
    pol: 'POL',
    pod: 'POD',
    eta: 'ETA',
    actualEndTime: 'Work End Time',
    releaseStatus: 'BL Release Status',
    changeStatus: 'DO Release Status',
    takeContainer: 'CY',
    rate: 'Rate',
    containerType: 'Type',
    quantity: 'Quantity',
    weight: 'Weight',
    size: 'CNTR Size',
    uploadDate: 'Discharge Date',
    demToDate: 'DEM Free To',
    FreeDays: 'Free Days',
    importFee: 'Inbound',
    chargeCode: 'Charge Type',
    amount: 'Amount',
    currency: 'Currency'
  },
  placeholder: {
    userName: 'ID User Name / Login Account',
    name: 'Name',
    password: 'Password',
    code: 'Verification code',
    emailAddress: 'Email is used for user activation of accounts. Please ensure that the email address can be used normally',
    pol: 'POL',
    pod: 'POD',
    vesselName: 'Vessel Name',
    blNo: 'B/L No.',
    bkNo: 'Booking No',
    containerNo: 'Container No.',
    date: 'Start Date',
    refNo: 'Ref No.',
    txtInfo: 'Please enter information',
    vesselCode: 'Vessel Code',
    voyageNo: 'Voyage No.',
    voyageLeg: 'Voyage Leg',
    bookingNo: 'Booking No.'
  },
  validate: {
    userNameNotNull: 'User name is null',
    userNameISNull: 'User name is not empty',
    userNameExist: 'User name already exists',
    containerNoIsFixed: 'ContainerNo is limited to 11 digits',
    userNameIsWrong: 'User name is no less than five and no more than twenty-five',
    nameIsNull: 'Name is not null',
    passwordNotNull: 'Password is null',
    passwordIsShort: 'Password is not less than six',
    passwordIsSimple: 'Must contain uppercase and lowercase letters as well as special characters',
    passwordNotTrue: 'Incorrect password entered twice',
    emailNotNull: 'Email is null',
    authorizeCodeNotExist: 'Authorize Code is not exist,Please send an email to email: cs-shipping@sitc.com to obtain',
    authorizeCodeNotNull: 'Authorize Code is null,Please send an email to email: cs-shipping@sitc.com to obtain',
    emailNotTrue: 'E-mail format is incorrect',
    code: 'code is Null',
    pol: 'POL is Null',
    pod: 'POD is Null',
    vesselName: 'Vessel Name is null',
    blNo: 'B/L No is null',
    bkNo: 'Booking No is null',
    containerNo: 'Container No is null',
    date: 'Start Date is null',
    checkBlNo: 'blNo or containerNo is wrong !',
    inputNo: 'inputNo is null',
    refNo: 'refNo is null',
    bookingNo: 'Booking No is null'
  },
  button: {
    search: 'Search',
    reset: 'Reset',
    edit: 'Edit',
    view: 'View',
    delete: 'Delete',
    save: 'Save',
    saveCopy: 'Save&Copy',
    saveNew: 'Save&New',
    back: 'Back',
    new: 'New',
    copy: 'Copy',
    excel: 'Excel',
    print: 'Print',
    pdf: 'Pdf',
    importExcel: 'Import Excel',
    excelTemplate: 'Excel Template',
    sure: 'Sure',
    cancel: 'Cancel'
  }
};